import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps, Switch } from 'react-router-dom';

import MainFrame from '../../components/mainFrame/index';
import { fomatParentPath, isMobile, isMobileUa, isMobileUrl } from '../../utils';
import {
  MobMainFrame,
  Page404,
  LayoutLogin
} from '../../lib';
import { getAsyncHook } from '@weapp/utils';
import { layoutPublicUrl } from '../../constants';

import '../../style/index.less';

function renderFrame(props: any) {
  const isUkTeams = window.location.href.indexOf('/mobile/uk/teams') > -1;
  if (window.location.pathname === '/' || window.location.pathname === layoutPublicUrl || window.location.pathname === layoutPublicUrl + '/') {
    if (isMobileUa()) {
      if (window.inExternalSpace) {
        window.location.href = `${layoutPublicUrl}/mobile/eb/wechat/external/home`;
      }
      return <MobMainFrame weId={`_u6amq6`} {...props} />
    } else {
      const hook = getAsyncHook('weappLayout', 'beforeThemeRender');
      if (hook) {
        hook(0)
      }
      return <MainFrame weId={`${props.weId || ''}_xjkpq2`} {...props} />
    }
  } else {
    if (isMobileUrl()) {
      if (window.inExternalSpace && !isUkTeams) {
        window.location.href = `${layoutPublicUrl}/mobile/eb/wechat/external/home`;
      }
      return <MobMainFrame weId={`_u6amq6`} {...props} />
    }
    const hook = getAsyncHook('weappLayout', 'beforeThemeRender');
    if (hook) {
      hook(0)
    }
    return <MainFrame weId={`${props.weId || ''}_xjkpq2`} {...props} />
  }
}



function RouteLayout(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Switch weId={`${props.weId || ''}_sa2zv8`}>
      <Route weId={`${props.weId || ''}_c926g8`} path={`${parentPath}/404`}>
        {
          isMobile()
            ? ''
            : <Page404 weId={`${props.weId || ''}_u6amq6`} {...props} />
        }
      </Route>
      <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/layoutlogin`} component={LayoutLogin} />
      {/* 后期提一个父组件处理内部渲染 */}
      <Route weId={`${props.weId || ''}_pb8iga`} path={`${parentPath}`}>
        {renderFrame(props)}
      </Route>
    </Switch>
  )
}

export default withRouter(RouteLayout);